import React from 'react';
import Background from "../../../assets/images/background/banner.jpg";
import "./Erp-Crp.css";
import { Link } from 'react-router-dom';

import Arrow from "../../../assets/images/Services/right-arrow.png"


import img1 from "../../../assets/images/Services/ERP-CRM/erp-crm-solution-img-1.jpg"; // left image
import img2 from "../../../assets/images/Services/ERP-CRM/erp-crm-solution-img-2.jpg"; // right image

import SEO from '../../seo';

export default function ErpCrp() {
    const pageKeywords = [
        "react website",
        "static pages",
        "web development",
        "SEO services"
    ];
    return (
        <div>
            <SEO
                title="ERP/CRM Solution | Horizon WebInfo Pvt Ltd"
                description="At Horizon WebInfo Pvt Ltd, we&#8217;re dedicated to revolutionizing the way your business operates through cutting-edge Enterprise Resource Planning (ERP) and Customer Relationship Management (CRM) solutions. Our expertise lies in leveraging sophisticated technology to streamline processes, enhance productivity, and drive sustainable growth for your business. Services Offered : Tailored ERP Implementation We understand that every [&hellip;]"
                canonical="https://www.hwplindia.com/service/erp-crm-solution/"
                ogImage="https://www.hwplindia.com/wp-content/uploads/2023/12/erp-crm-solution-img.jpg"
                keywords={pageKeywords}
            />
            <section
                className="page-title"
                style={{ backgroundImage: `url(${Background})` }}
            >
                <div className="auto-container">
                    <h2>ERP/CRM Solution</h2>
                    <ul className="bread-crumb clearfix">
                        <li>
                            <Link to="/">Home</Link>
                        </li>

                        <li className="icon-separator">
                            <span className="double-arrow">
                                <i className="fas fa-angle-right"></i>
                                <i className="fas fa-angle-right"></i>
                            </span>
                        </li>

                        <li><Link to="/services">Services</Link></li>

                        <li className="icon-separator">
                            <span className="double-arrow">
                                <i className="fas fa-angle-right"></i>
                                <i className="fas fa-angle-right"></i>
                            </span>
                        </li>

                        <li>ERP/CRM Solution</li>
                    </ul>
                </div>
            </section>
            <section className="branding-section">
                <div className="branding-container">
                    {/* Images Section */}
                    <div className="branding-images">
                        <img src={img1} alt="branding" className="branding-img" />
                        <img src={img2} alt="branding" className="branding-img" />
                    </div>

                    {/* Content Section */}
                    <div className="branding-content">
                        {/* CTA */}
                        <section className="cta-section">
                            <p>
                                At Horizon Webinfo Pvt. Ltd. we’re dedicated to revolutionizing the way your business operates through cutting-edge Enterprise Resource Planning (ERP) and Customer Relationship Management (CRM) solutions. Our expertise lies in leveraging sophisticated technology to streamline processes, enhance productivity, and drive sustainable growth for your business.
                            </p>
                            <h3 className='cta-section-business-process it-consult'>Services Offered :</h3>
                        </section>


                        {/* Sections */}
                        <section className='it-consult'>
                            <section className="branding-item">
                                <h4><img src={Arrow} />

                                    Tailored ERP Implementation</h4>
                                <p>
                                    We understand that every business has unique needs. Our team excels in designing and implementing customized ERP solutions that seamlessly integrate into your existing workflows. From resource planning to inventory management and beyond, we ensure your operations are optimized for efficiency.
                                </p>
                            </section>
                            <section className="branding-item">
                                <h4><img src={Arrow} />
                                    Comprehensive CRM Development</h4>
                                <p>
                                    Building strong relationships with your customers is pivotal. Our CRM development services empower you to manage interactions, track leads, and nurture customer relationships effectively. We create intuitive CRM systems tailored to your specific business requirements, enhancing customer satisfaction and loyalty.
                                </p>
                            </section>
                            <section className="branding-item">
                                <h4><img src={Arrow} />
                                    Integration and Customization</h4>
                                <p>
                                    Our expertise extends beyond standalone solutions. We specialize in integrating ERP/CRM systems with other software and platforms your business relies on. Additionally, we offer customization services to align the solutions precisely with your operational workflows.
                                </p>
                            </section>

                            <section className="branding-item">
                                <h4><img src={Arrow} />
                                    Training and Support</h4>
                                <p>
                                    Adopting new systems can be daunting. That's why we provide comprehensive training sessions to ensure your team is well-equipped to leverage the full potential of the ERP/CRM solutions. Our support doesn't end after implementation; we offer ongoing assistance to address any queries or concerns.
                                </p>
                            </section>
                            {/* Why Choose Us */}
                            <section className="why-choose">
                                <h3>Why Choose Us</h3>
                                <ul>
                                    <li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i>
                                        Our team comprises experts well-versed in ERP/CRM technologies, offering insightful guidance to help you choose the best solutions for your business.</li>
                                    <li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i>
                                        We believe in crafting solutions tailored to your unique business needs, ensuring maximum efficiency and effectiveness.</li>
                                    <li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i>
                                        Our solutions are designed to grow with your business, adaptable to changes and expansions, ensuring long-term value.</li>
                                    <li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i>
                                        We prioritize the security of your data, implementing robust measures to safeguard sensitive information and ensuring compliance with industry standards.</li>
                                    <li><i className="fas fa-angle-double-right" style={{ color: "#F22A2B", fontSize: "18px" }}></i>
                                        With a history of successful ERP/CRM implementations and satisfied clients, we bring a wealth of experience to every project.</li>
                                </ul>
                            </section>

                            {/* CTA */}
                            <section className="cta-section">
                                <h3>Let's Transform Your Business Operations!</h3>
                                <p>
                                    Ready to optimize your business processes and elevate customer relationships? Partner with Horizon Webinfo for unparalleled ERP/CRM solutions that drive efficiency, productivity, and growth. Contact us today to discuss how our tailored solutions can take your business to new heights!
                                </p>
                                <Link to="/get-a-quote" className="quote-btn1-brand">
                                    <span><i aria-hidden="true" class="fas fa-external-link-alt"></i> GET A QUOTE</span>
                                </Link>
                            </section>
                        </section>
                    </div>
                </div>
            </section>
        </div>
    );
}